export const ADD_ADVICES = 'ADD_ADVICES'